import { NgModule, SkipSelf, Optional, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { TooltipModule } from 'ngx-bootstrap';

import { MenuComponent } from './menu.component';
import { MenuService } from './menu.service'
import { DetailedMenuComponent } from './detailed-menu.component';
import { CoreModule } from '../core/core.module';

@NgModule({
    imports: [CommonModule, TooltipModule.forRoot()],//FormsModule
    declarations: [MenuComponent, DetailedMenuComponent],
    exports: [MenuComponent, DetailedMenuComponent],
})
export class MenuModule {
    constructor() {
      
    }
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: MenuModule,
            providers: [MenuService]
        }; //return ends
    } //static forRoot ends


}